import { DefaultService } from '@/services/DefaultService';

export default class ParametrizacaoUsuarioService extends DefaultService {
    
    constructor(http, router, env) {
        super(http, router, env)
    }

    findAll(page, limit, situacao, ...params) {
        return this._http.get(encodeURI(`${this._env}/config/usuario/parametrizacoes.json?page=${page}&limit=${limit}&situacao=${situacao}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    getAllUsersConfigsByValueAndName(nome,valor) {
        return this._http.get(encodeURI(`${this._env}/config/usuario/getconfigsbyvalue.json?nome=${nome}&valor=${valor}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    save(lista) {
        return this._http.post(`${this._env}/config/usuario`, lista, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    getConfigByNomeIdusuario(nome, idusuario) {
		return this._http.get(`${this._env}/config/usuario/parametrizacao/${nome}/${idusuario}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}
}